import axios from 'axios'
import { config } from '@/config/index'

const http = axios.create({ baseURL: `${config.API_URL}` })

export async function requestError (promisse) {
  try {
    let response = await promisse
    return response.data || {}
  } catch (error) {
    let message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message
    throw new Error(message)
  }
}

export default {
  async get (url) {
    return requestError(http.get(url))
  },
  async post (url, data) {
    return requestError(http.post(url, data))
  },
  async put (url, data, acesso = {}) {
    return requestError(http.put(url, data))
  },
  async delete (url) {
    return requestError(http.delete(url))
  }
}
